import script from "./SplitView.vue?vue&type=script&setup=true&lang=js"
export * from "./SplitView.vue?vue&type=script&setup=true&lang=js"

import "./SplitView.vue?vue&type=style&index=0&id=959cc1ca&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-959cc1ca"]])

export default __exports__